// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"65c6ff57","627":"4c3dd0ef","656":"9b1e1926","738":"7d785ce6","801":"68b08864","923":"1c3bdc4f"}[chunkId] + ".chunk.js";
};